export var validCurrencies = ['AUD', 'EUR', 'GBP', 'USD'];